import api from './api'
import publicApi from './publicApi';


export const getBlogBanners = (slug, placement = null) => {
  const url = placement
    ? `adverts/${slug}/banners/?placement=${placement}`
    : `adverts/${slug}/banners/`;

  return publicApi.get(url);
};